import React from 'react';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import { getStatusColor } from '../../../../utils/appointmentUtils';
import {
  getServiceDisplayName,
  getStaffDisplayName,
  normalizeStatusForColorLookup,
  formatAppointmentStatusLabel,
} from '../utils/appointmentDisplay';
import { hexToRgba } from '../utils/statusBadgeStyle';

const StorefrontAppointmentHistoryCard = ({ appointment, detailHref }) => {
  const navigate = useNavigate();
  const title = getServiceDisplayName(appointment);
  const staff = getStaffDisplayName(appointment);
  const when = format(appointment.startTime, 'EEE, MMM d, yyyy · h:mm a');
  const statusRaw = appointment.status || (appointment.isArchived ? 'archived' : '');
  const statusLabel = formatAppointmentStatusLabel(statusRaw);
  const colorKey = normalizeStatusForColorLookup(statusRaw);
  const statusColor = getStatusColor(colorKey || 'default');

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      navigate(detailHref);
    }
  };

  return (
    <article
      className="sf-ah-card"
      role="button"
      tabIndex={0}
      onClick={() => navigate(detailHref)}
      onKeyDown={handleKeyDown}
    >
      <div className="sf-ah-card__main">
        <h2 className="sf-ah-card__title">{title}</h2>
        <p className="sf-ah-card__meta">{when}</p>
        <p className="sf-ah-card__meta sf-ah-card__meta--muted">with {staff}</p>
      </div>
      {statusLabel ? (
        <span
          className="sf-ah-card__status"
          style={{
            backgroundColor: hexToRgba(statusColor, 0.2),
            color: statusColor,
          }}
        >
          {statusLabel}
        </span>
      ) : null}
      <span className="sf-ah-card__chevron" aria-hidden>→</span>
    </article>
  );
};

export default StorefrontAppointmentHistoryCard;
